import React, { createContext, useCallback, useContext, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { Tokens } from '../../../types';

import { Toast } from '../Toast';
import { ToastMessage } from '../Toast.types';
// export interface ToastMessage {
//   id: string;
//   type?: 'success' | 'error' | 'info';
//   title: string;
//   description?: string;
// }
interface ToastContextData {
  addToast(message: Omit<ToastMessage, 'id'>): void;
  removeToast(id: string): void;
}
const ToastContext = createContext<ToastContextData>({} as ToastContextData);

const ToastProvider = ({ children }) => {
  const [messages, setMessages] = useState<ToastMessage[]>([]);

  const removeToast = useCallback((id: string) => {
    setMessages(state => state.filter(message => message.id !== id));
  }, []);

  const addToast = useCallback(
    ({ type, title, description, container }: Omit<ToastMessage, 'id'>) => {
      const id = uuidv4();

      const toast = {
        id,
        title,
        type,
        description,
        container,
      };

      setMessages(state => [...state, toast]);
      if (!container) {
        const timer = setTimeout(() => removeToast(id), Tokens.toast.duration);
        return () => {
          clearTimeout(timer);
        };
      }
    },
    [removeToast],
  );

  return (
    <ToastContext.Provider value={{ addToast, removeToast }}>
      {children}
      <Toast messages={messages} />
    </ToastContext.Provider>
  );
};

function useToast(): ToastContextData {
  const context = useContext(ToastContext);

  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }

  return context;
}

export { ToastProvider, useToast };
